import {
  FourHundredError,
  is4XXError,
  isBadRequestError,
} from "@repo/chameleon-request";
import { BagApiBadRequestError } from "../errors";
import type { BagSdkConfig } from "../sdk";
import { cache } from "./cache";

export const handleApiInteractionError = async (
  config: BagSdkConfig,
  error: unknown,
): Promise<never> => {
  if (isBadRequestError(error)) {
    const badRequestError = error as FourHundredError;
    throw new BagApiBadRequestError(
      badRequestError.message,
      badRequestError.httpResponseBody,
    );
  }

  if (is4XXError(error)) {
    await cache.init(config);
  }

  throw error;
};
